import { Box, Stack, Typography } from "@mui/material";
import Etiqueta from "../kit/Etiqueta";
import { InstanciaPaso } from "../../types/instanciaPaso";
import ProcesoCard from "./ProcesoCard";

/**
 * Procesos agrupados por semestre (año + semestre). Preserva el orden del backend
 * (año desc, semestre desc, fecha de entrega desc), así que basta agrupar en secuencia.
 */
export default function ProcesosPorSemestre({
  instancias,
  showEstudiante = true,
  gestionCoordinador = false,
}: {
  instancias: InstanciaPaso[];
  showEstudiante?: boolean;
  gestionCoordinador?: boolean;
}) {
  const grupos: { key: string; label: string; items: InstanciaPaso[] }[] = [];
  const idx = new Map<string, number>();
  for (const it of instancias) {
    const key = `${it.ano}.${it.semestre}`;
    if (!idx.has(key)) {
      idx.set(key, grupos.length);
      grupos.push({ key, label: `${it.ano} · ${it.semestre_display}`, items: [] });
    }
    grupos[idx.get(key) as number].items.push(it);
  }

  return (
    <Stack spacing={3.5}>
      {grupos.map((g) => (
        <Box key={g.key}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
            <Typography variant="h6">{g.label}</Typography>
            <Etiqueta variante="contorno">{g.items.length}</Etiqueta>
          </Stack>
          <Stack spacing={2}>
            {g.items.map((it) => (
              <ProcesoCard
                key={it.id}
                it={it}
                showEstudiante={showEstudiante}
                gestionCoordinador={gestionCoordinador}
                mostrarPeriodo={false}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
